import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { MaterialModule } from '@ebw-monorepo/material';
import { EbwModalComponent } from './modal/ebw-modal/ebw-modal.component';
import { HiddenModalButtonComponent } from './modal/hidden-modal-button/hidden-modal-button.component';
import { EbwModalService } from './modal/service/ebw-modal.service';
@NgModule({
  imports: [CommonModule, FormsModule, MaterialModule, I18NTranslateModule, ReactiveFormsModule],
  declarations: [EbwModalComponent, HiddenModalButtonComponent],
  exports: [EbwModalComponent, HiddenModalButtonComponent],
  providers: [EbwModalService]
})
export class ModalModule {}
